import script from "./SignupSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupSuccess.vue?vue&type=script&setup=true&lang=js"

import "./SignupSuccess.vue?vue&type=style&index=0&id=7b88e6f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b88e6f6"]])

export default __exports__